
































































import ModpackService from "@/classes/ModpackService";
import { ModpackInterface, ServerInterface } from "@/types";
import User from "@/User";
import Vue from "vue";
import Component from "vue-class-component";
import { PropSync } from "vue-property-decorator";
import ModpackUploadDialog from "./events/editor/ModpackUploadDialog.vue";
import ModlistCard from "./mods/ModlistCard.vue";

@Component({
  components: { ModlistCard, ModpackUploadDialog },
})
export default class Event extends Vue {

  get ip(): string {
    return this.serverProp && this.serverProp.addr ? this.serverProp.addr.split(":")[0] : "";
  }
  @PropSync("server")
  public serverProp!: ServerInterface | undefined;

  public modpacks: ModpackInterface[] = [];

  public selectedModpack: number = 0;

  public moderator: boolean = false;

  public forceDownloading: boolean = false;

  public showRedownloadDialog: boolean = false;

  get modCount(): number {
    return this.serverProp && this.serverProp.modpack ? this.serverProp.modpack.mods.length : 0;
  }

  public async mounted() {
    await this.refreshModpacks();
    if (this.serverProp && this.serverProp.modpack) {
      this.selectedModpack = this.serverProp.modpack.id;
    }
  }

  public async refreshModpacks() {
    this.modpacks = await ModpackService.getModpacks();
  }

  public async restartServer() {
    await this.axios.post("arma/server", {
      modpackId: this.selectedModpack,
    });
    this.$router.go(0);
  }

  public async forceDownloadAllMods() {
    const modpack = this.serverProp && this.serverProp.modpack;
    if (!modpack || !modpack.mods.length) {
      return;
    }
    this.forceDownloading = true;
    try {
      await this.axios.patch(`arma/modpacks/${modpack.id}`, { force: true });
      this.$router.push("/mod-downloads");
    } catch (e) {
      this.$store.dispatch("showErrorSnackbar", "Failed to queue mod downloads.");
    } finally {
      this.forceDownloading = false;
      this.showRedownloadDialog = false;
    }
  }

  public async created() {
    this.moderator = await User.isModerator();
  }

  public async isModerator() {
    return await User.isModerator();
  }
}
